<template>
    <div v-if="facet.name && ![28,30,31,32,33,34,35,36,37,38,39,40,41,42,43,44,45,46,47,48,49,50,51,52,53].includes(facet.id)" :class="'item-filter__wrapper item-filter__wrapper--' + facet.id">
        <div v-if="filterType === 'sidebar' || isMobile">
            <button class="btn btn-white filter-toggle collapsed"
                    data-toggle="collapse"
                    :data-target="'#filter-collapse_' + facet.id"
                    aria-expanded="false" :aria-controls="'filter-collapse_' + _uid">
                {{ facetName }}
                <span>
                    <span v-if="activeFacets.length > 3" class="badge badge-light badge-pill">
                        ...
                    </span>
                    <i class="fa fa-angle-up ml-2"></i>
                </span>
            </button>
        </div>
        <button v-else class="btn btn-outline-dark dropdown-toggle" type="button"
                id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
            {{ facetName }}
        </button>
        <div :class="wrapperClasses" :id="'filter-collapse_' + facet.id">
            <button class="item-filter__reset" v-show="activeFacets && activeFacets.length > 0" @click="clearFacet()">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="15">
                    <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#svg-reset"></use>
                </svg>
                {{ $translate('OD3dprimaV2::Template.categoryResetFilter') }}
            </button>
            <template v-if="facet.type === 'price'">
                <item-filter-price></item-filter-price>
            </template>
            <template v-else>
                <input v-if="facets.length > 8 && !notSearchFacetIds.includes(facet.id)"
                       type="text"
                       class="form-control"
                       v-model="searchString"
                       :placeholder="$translate('OD3dprimaV2::Template.itemSearchSearchTerm')">
                <div class="item-filter__scroll"
                     :class="facets.length > 8 && !notSearchFacetIds.includes(facet.id) ? 'item-filter__scroll--lg-max-height' : ''">
                    <div v-for="value in displayFacets"
                         class="item-filter__item custom-control custom-checkbox" :class="value.cssClass"
                         :key="value.id">
                        <label v-if="colorFacetIds.includes(facet.id)"
                               class="item-filter__item-color-label"
                               :class="{'item-filter--active': isSelected(value.id)}"
                               :for="'option-' + value.id">
                        <span class="item-filter__item-color">
                            <div class="item-filter__item-color--inner"
                               :class="'item-filter__item-color--'+value.cssClass"
                               v-tooltip
                               data-toggle="tooltip"
                               data-placement="top"
                               :title="value.name"></div>
                        </span>
                            <!-- TODO: checked color close icon -->
                            <input type="checkbox"
                                   :id="'option-' + value.id"
                                   :checked="isSelected(value.id)"
                                   @change="updateFacet(value)"
                                   :disabled="isLoading">
                            <span class="item-filter__item-checkmark d-none"></span>
                        </label>
                        <template v-else>
                            <input :id="'option-' + value.id"
                                   class="custom-control-input item-filter__checkbox"
                                   type="checkbox"
                                   :checked="isSelected(value.id)"
                                   @change="updateFacet(value)"
                                   :disabled="isLoading || value.count <= 0">
                            <label :for="'option-' + value.id" class="item-filter__label custom-control-label"
                                   :class="[paddingClasses, isSelected(value.id) ? 'item-filter__label--active' : '']">
                                {{ value.name }}
                            </label>
                        </template>
                    </div>
                </div>
            </template>
        </div>
    </div>
</template>

<script>
import {mapState} from 'vuex';
import ItemFilterPrice from './ItemFilterPrice.vue';
import _ from 'lodash';

export default {

    name: 'item-filter',

    components:
        {
            ItemFilterPrice,
        },

    props:
        {
            isMobile: {
                type: Boolean,
                default: false,
            },
            filterType: {
                type: String,
                default: 'dropdown',
            },
            facet:
                {
                    type: Object,
                },
            paddingClasses:
                {
                    type: String,
                    default: null,
                },
            paddingInlineStyles:
                {
                    type: String,
                    default: null,
                },
        },
    data() {
        return {
            searchString: '',
            colorFacetIds: [4],
            notSearchFacetIds: [4, 20, 22],
            notSortFacetIds: [4, 20, 22]
        };
    },
    computed:
        {
            facets() {
                return this.facet.values;
            },
            displayFacets() {

                let that = this;
                let facets = this.facets;

                // if (!this.notSortFacetIds.includes(this.facet.id)) {
                //     facets = _.sortBy(this.facets, ['name']);
                // }

                if (this.searchString.length > 0) {
                    return facets.filter(facet => facet.name.toLowerCase().includes(that.searchString.toLowerCase()));
                }

                return facets;
            },
            activeFacets() {
                let selectedFacetIds = _.map(this.selectedFacets, 'id');
                return this.facets.filter(facet => selectedFacetIds.includes(facet.id));
            },
            facetName() {
                if (this.facet.translationKey && this.facet.translationKey.length > 0) {
                    return this.$translate('Ceres::Template.' + this.facet.translationKey);
                }

                return this.facet.name;
            },
            wrapperClasses() {
                return this.filterType === 'sidebar' || this.isMobile
                    ? 'item-filter__collapse collapse'
                    : 'dropdown-menu item-filter__dropdown-menu item-filter__dropdown-menu keep-open';
            },
            ...mapState({
                selectedFacets: state => state.itemList.selectedFacets,
                isLoading: state => state.itemList.isLoading,
            })
        },

    methods:
        {
            updateFacet(facetValue) {
                const toolbarElements = document.getElementsByClassName("widget-toolbar");

                for (const toolbarElement of toolbarElements)
                {
                    if (toolbarElement.contains(this.$vnode.elm))
                    {
                        window.localStorage.setItem("openFilterToolbar", true);
                    }
                }

                this.$store.dispatch("selectFacet", { facetValue });
            },

            isSelected(facetValueId) {
                return this.selectedFacets.findIndex(selectedFacet => selectedFacet.id === facetValueId) > -1;
            },

            clearFacet() {
                this.$store.commit('setSelectedFacetsByIds', this.activeFacets);
                this.$store.dispatch('loadItemList');
            },
        },
};
</script>
